"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _ThemeHelper = require("../Utilities/ThemeHelper");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _ListItem = _interopRequireDefault(require("../ListItem"));

var _ListSubheader = _interopRequireDefault(require("../ListSubheader"));

var _reactSortablejs = _interopRequireDefault(require("react-sortablejs"));

var _excluded = ["id", "className", "listItems", "subheader", "listSubheader", "subheaders", "onChange", "wrapperStyles", "sideNav", "draggable"],
    _excluded2 = ["listItems"];
var useStyles = (0, _ThemeHelper.makeStyles)(function (theme) {
  return {
    hasPaper: {
      background: theme.palette.background.paper,
      border: "1px solid ".concat(theme.palette.divider),
      borderRadius: 2,
      padding: 0
    },
    noPaper: {
      padding: 0,
      backgroundColor: "inherit"
    },
    isSortable: {
      cursor: "move"
    },
    sideNav: {
      background: theme.palette.background.paper,
      "& .prmbl-touchRipple": {
        color: theme.palette.primary.main
      }
    }
  };
});

var List = function List(props) {
  var id = props.id,
      className = props.className,
      listItems = props.listItems,
      subheader = props.subheader,
      listSubheader = props.listSubheader,
      subheaders = props.subheaders,
      _onChange = props.onChange,
      wrapperStyles = props.wrapperStyles,
      sideNav = props.sideNav,
      draggable = props.draggable,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = useStyles();
  if (!listItems && !subheaders) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  var inner = listItems === null || listItems === void 0 ? void 0 : listItems.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement(_ListItem.default, (0, _extends2.default)({
      key: i
    }, item));
  });
  return /*#__PURE__*/_react.default.createElement(_List.default, (0, _extends2.default)({
    id: id
  }, otherProps, {
    className: (0, _classnames.default)("prmbl-list", className, wrapperStyles ? classes.hasPaper : classes.noPaper, (0, _defineProperty2.default)({}, classes.sideNav, sideNav)),
    subheader: subheader || listSubheader || undefined
  }), draggable ? /*#__PURE__*/_react.default.createElement(_reactSortablejs.default, {
    onChange: function onChange(order, sortable, evt) {
      _onChange && _onChange(order, sortable, evt);
    },
    options: {
      name: id,
      // If same name, columns can drag and drop between
      pull: false,
      // Allow items from this list to be pulled out
      put: false // Allows items from other lists to be put into this list

    }
  }, inner) : inner, subheaders === null || subheaders === void 0 ? void 0 : subheaders.map(function (sh, i) {
    var listItems = sh.listItems,
        otherProps = (0, _objectWithoutProperties2.default)(sh, _excluded2);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: "subheader-wrapper-".concat(i)
    }, /*#__PURE__*/_react.default.createElement(_ListSubheader.default, (0, _extends2.default)({
      id: id ? "".concat(id, "-listSubheader-").concat(i) : undefined
    }, otherProps)), listItems === null || listItems === void 0 ? void 0 : listItems.map(function (item, i) {
      return /*#__PURE__*/_react.default.createElement(_ListItem.default, (0, _extends2.default)({
        key: i
      }, item));
    }));
  }));
};

var _default = List;
exports.default = _default;